export default __webpack_public_path__ + "static/tech-windowsserverclient-d6653bdec5086a2dff2aaa93a8fdd5ed-d6653bdec5086a2dff2aaa93a8fdd5ed.png";